import { render, staticRenderFns } from "./StatusPayment.vue?vue&type=template&id=3b21f356&scoped=true&"
import script from "./StatusPayment.vue?vue&type=script&lang=ts&"
export * from "./StatusPayment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b21f356",
  null
  
)

export default component.exports